import { render, staticRenderFns } from "./priceDescription.vue?vue&type=template&id=13d3fbc4&scoped=true"
import script from "./priceDescription.vue?vue&type=script&lang=js"
export * from "./priceDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3fbc4",
  null
  
)

export default component.exports